import { z } from 'zod';

import { AlertType } from '@/entities/alert-type';

import { AlertStatus } from './alert-status';
import { TaskCardType } from './task-card-type';
import { taskPrioritySchema } from './task-priority';
import type { TaskProjectManagement } from './task-project-management';
import { taskStatusSchema } from './task-status';

export const TaskPreviewSchema = z.object({
  id: z.string(),
  title: z.string(),
  subtitle: z.string().optional(),
  status: taskStatusSchema,
  priority: taskPrioritySchema,
  cardType: z.nativeEnum(TaskCardType),
});

export type TaskPreview = z.infer<typeof TaskPreviewSchema> &
  (
    | {
        cardType: TaskCardType.STANDARD;
        projectManagement?: TaskProjectManagement;
      }
    | { cardType: TaskCardType.DATA_ONBOARDING_INCIDENT }
    | {
        cardType: TaskCardType.ALERT;
        alert?: AlertInfoPreview;
      }
  );

export type AlertInfoPreview = {
  status?: AlertStatus;
  type?: AlertType;
  suggestedAction: string;
  resolved: boolean;
};
